import qs from 'query-string';

import * as translationsApi from '../../api/translations';
import * as Urls from '../../constants/Urls';
import { parseLegacyURL } from '../../utils/legacyRouteMapper';

export const getTranslatedEntityName = (entity) => {
  const value = entity.translatedEntityName;
  if (value) {
    return Promise.resolve(value);
  }
  return translationsApi.translateString(entity.entityName).then((data) => data.Translation);
};

export const getNextStepLink = (entity) => {
  if (entity.entityURL) {
    return parseLegacyURL(entity.entityURL, true);
  }

  return {
    pathname: Urls.ENTITY_DISPLAY,
    search: qs.stringify({
      itmId: entity.itmId,
      entityType: entity.entityType,
      formKey: entity.formKey,
      entityName: entity.entityName,
    }),
  };
};
